import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '~/app/store'
import { PrintersKeysType } from '~/shared/api/services/users/types'
import { CustomSelect } from '~/shared/ui'
import Preloader from '~/shared/ui/preloader'

const printersKeys: PrintersKeysType[] = ['text', 'label', 'zpl']

interface PrinterSettingsProps {
  onChange: (key: string, value: string) => void
  selectedPrinters: Record<
    string,
    { label: string | number; value: string | number }
  >
  className?: string
}

export const PrinterSettings = observer((props: PrinterSettingsProps) => {
  const { t } = useTranslation(['common', 'profile'])
  const { onChange, selectedPrinters, className } = props
  const { printerStore } = useStore()
  const { getPrinters, printers, isLoading } = printerStore

  useEffect(() => {
    getPrinters()
  }, [getPrinters])

  const getLabel = (key: PrintersKeysType) => {
    const labels: Record<PrintersKeysType, string> = {
      text: t('profile:textPrinter'),
      label: t('profile:labelPrinter'),
      zpl: t('profile:zplPrinter'),
    }

    return labels[key]
  }

  const getSelectValue = (key: PrintersKeysType) => {
    const value = selectedPrinters?.[key]
    if (!value) {
      return { value: '', label: '' }
    }
    return {
      value: String(value.value),
      label: String(value.label),
    }
  }

  return (
    <>
      <p className={className}>{t('profile:userPrinters')}</p>
      {!isLoading ? (
        printersKeys.map((key) => {
          const printerGroup = printers[key]
          if (!printerGroup) {
            return null
          }

          const options = Object.entries(printerGroup).map(
            ([printerKey, printerValue]) => ({
              label: printerKey,
              value: printerValue,
            }),
          )

          return (
            <div key={key}>
              <p className="pb-2 font-medium">{getLabel(key)}</p>

              <CustomSelect
                options={options}
                value={getSelectValue(key)}
                onChange={(e: unknown) => {
                  const select = e as { value: string | number; label?: string }
                  onChange(key, String(select.value))
                }}
                customLabel={getLabel(key)}
                labelType="floating"
                placeholder={getLabel(key)}
              />
            </div>
          )
        })
      ) : (
        <Preloader />
      )}
    </>
  )
})
